import { EditorStep } from '@/features/product-editor/components/EditorComponents/EditorStep';
import StoreCardStyle from './EditorComponents/StoreCardStyle/StoreCardStyle';
import { PRODUCT_TYPES } from '@/lib/constants';
import { useMemo } from 'react';
import { usePageDataStore } from '@/features/product-editor/pageStore';
import StoreThumbnailSelector from './EditorComponents/StoreThumbnailSelector/StoreThumbnailSelector';
import StoreCardDetails from './EditorComponents/StoreCardDetails/StoreCardDetails';
import { ProductType } from '@/types/store';
import FormFields from './EditorComponents/FormFields/FormFields';

const SECTIONS: Record<
    string,
    {
        id: string;
        title: string;
        component: React.ReactNode;
        exludedProducts?: ProductType[];
        includedProducts?: ProductType[];
    }
> = {
    THUMBNAIL: {
        id: 'THUMBNAIL',
        title: 'Pick a Style',
        component: <StoreCardStyle />,
        exludedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
    PHOTO: {
        id: 'PHOTO',
        title: 'Select image',
        component: <StoreThumbnailSelector />,
    },
    TEXT: {
        id: 'TEXT',
        title: 'Add text',
        component: <StoreCardDetails />,
    },
    COLLECT_INFO: {
        id: 'COLLECT_INFO',
        title: 'Collect info',
        component: <FormFields />,
        includedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
};

export default function StoreSection() {
    const { pageData } = usePageDataStore();

    const pageType = pageData.product.type;

    // Filter sections to show based on page type
    const sectionsToShow = useMemo(() => {
        return Object.values(SECTIONS).filter(section => {
            let include = true;
            if (section.exludedProducts) {
                include = include && !section.exludedProducts.includes(pageType);
            }
            if (section.includedProducts) {
                include = include && section.includedProducts.includes(pageType);
            }
            return include;
        });
    }, [pageType]);

    return (
        <div>
            {sectionsToShow.map((section, index) => (
                <div key={section.id}>
                    <EditorStep number={index + 1} title={section.title}>
                        {section.component}
                    </EditorStep>
                </div>
            ))}
        </div>
    );
}
